import DestacatPrograma from './DestacatPrograma';
import DestacatProgramaSkeleton from './DestacatPrograma.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatProgramaSkeleton {...props} /> : <DestacatPrograma {...props} />;
}
